var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"4","xl":"3"}},[_c('EnlaceBloque',{attrs:{"titulo":"MiEspacio. Datos personales actualizados","enlace":"mi-espacio-actualizaciones","icono":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }